import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  pure: false // Make it impure to update every few seconds
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    // Get current local time
    const now = new Date();
    
    // Convert server timestamp to local timezone
    let localTimestamp: Date;
    
    if (typeof value === 'string') {
      // If the string doesn't end with 'Z' or timezone info, assume it's UTC and convert to local
      if (value.endsWith('Z') || value.includes('+') || value.includes('-')) {
        // Already has timezone info, parse directly
        localTimestamp = new Date(value);
      } else {
        // Assume it's UTC, append 'Z' to make it clear and then convert to local
        localTimestamp = new Date(value + 'Z');
      }
    } else {
      localTimestamp = new Date(value);
    }
    
    // Calculate difference in seconds between current local time and converted local timestamp
    const seconds = Math.floor((now.getTime() - localTimestamp.getTime()) / 1000);

    // Handle future dates or very recent (just opened)
    if (seconds < 0) {
      return '0s ago';
    }

    // For very recent times (0-2 seconds), show 0s instead of just now
    if (seconds <= 2) {
      return '0s ago';
    }

    // Calculate time units
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    // Build the time ago string
    let timeAgo = '';

    if (hours > 0) {
      timeAgo += `${hours}h `;
    }
    if (minutes > 0 || hours > 0) {
      timeAgo += `${minutes}m `;
    }
    timeAgo += `${remainingSeconds}s ago`;

    return timeAgo;
  }
} 